import { IUserAccountStore } from '../index'

export default function(state: IUserAccountStore): IUserAccountStore {
  return {
    ...state,
    request: {
      ...state.request,
      isLoading: true,
    },
  }
}
